import * as XLSX from 'xlsx/xlsx.mjs'
import PropTypes from 'prop-types';
import { Button} from '@mui/material';



function ExcelExport({datos}) {
  const handleClick = () => {
    // Crear un libro de Excel y convertir el array en una hoja de cálculo
 const libro = XLSX.utils.book_new();
 const hoja = XLSX.utils.json_to_sheet(datos);
 XLSX.utils.book_append_sheet(libro, hoja, 'Producto');
 // Generar un archivo de Excel y descargarlo
 XLSX.writeFile(libro, 'Productos.xlsx');}

  return (
    <div>
      {(datos && datos.length !== 0) ? (
        
            <Button
              type='button'
              style={{ backgroundColor: 'orange', margin: 4, color: 'white' }} onClick={handleClick}>
              Exportar excel
            </Button>
          


      ) : null}
    </div>
  );
}
export default ExcelExport;
ExcelExport.propTypes = {
  datos: PropTypes.array,
}